var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "flex-column hp-10 jc-center ai-center br b-1 white-bkg" },
    [
      _c(
        "icon-svg",
        {
          attrs: {
            "icon-name": "confirmed",
            width: 117,
            height: 111,
            viewBox: "0 0 117 111"
          }
        },
        [_c("icon-check")],
        1
      ),
      _vm._v(" "),
      _c("h1", { staticClass: "mt-8 mb-0" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Tout est bon !")))
      ]),
      _vm._v(" "),
      _c("p", { staticClass: " mt-3 mb-4 fs-3 confirmed-subtitle acenter" }, [
        _vm._v(
          _vm._s(
            _vm.$l10n.__(
              "Vous pouvez désormais configurer une page publique pour que vos contacts programment un rendez-vous en toute autonomie."
            )
          )
        )
      ]),
      _vm._v(" "),
      _c("nylas-scheduler", { staticClass: "btn btn-primary" }, [
        _c("div", { attrs: { slot: "label" }, slot: "label" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.$l10n.__("Continuer")) + "\n        "
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }